import { DataSource } from '@/shared/models/data/data-source'
import { SearchRequest } from '@/shared/interfaces/search-request'
import { PageResponse } from '@/shared/interfaces/page-response'
import { Injector } from '@/config/dependency-injection'
import { OffersModule } from '@/business/offers/store/offers-module'
import { OfferResponsePartner } from '@/api/generated'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { FETCH_OFFER_PARTNERS } from '@/business/offers/store/types'

export class OfferPartnerDataSource extends DataSource<OfferResponsePartner> {
  private loaderHelper = Injector.get(LoaderHelper)
  private offersModule = Injector.get(OffersModule)

  public destroy(): void {
    //
  }

  public fetchData(request: SearchRequest): Promise<PageResponse<OfferResponsePartner>> {
    return this.offersModule.fetchOfferPartners({
      page: request.page,
      pageSize: request.pageSize,
    })
  }

  public isLoading(): boolean {
    return this.loaderHelper.isLoading(FETCH_OFFER_PARTNERS)
  }

  public get items(): OfferResponsePartner[] {
    return this.offersModule.offer.partners.items
  }
}
